import VModelMixin from "./vModelMixin";
import {mapMutations, mapState} from "vuex";

export default (fieldName) => ({
  mixins: [VModelMixin],

  data() {
    return {
      defaultLabel: null,
      defaultPlaceholder: null,
    }
  },

  props: {
    required: {
      type: Boolean,
      default: false
    },
    label: {
      required: false,
      default: function () {
        return this.defaultLabel
      }
    },
    placeholder: {
      required: false,
      default: function () {
        return this.defaultPlaceholder
      }
    },
  },
  computed: {
    ...mapState(['signup']),
    ...mapState({
      errors: state => {
        if (fieldName.startsWith('billing_address.') || fieldName.startsWith('shipping_address.') || fieldName.startsWith('identification.') || fieldName.startsWith('bank_account.')) {
          const fields = fieldName.split('.');
          let iden = state.signup.errors[fields[0]];
          if (iden && iden.length > 0) {
            return iden[0][fields[1]];
          }
          return '';
        }

        return state.signup.errors[fieldName]
      }
    }),
    computedLabel() {
      return this.label || this.defaultLabel
    },
    computedPlaceholder() {
      return this.placeholder || this.defaultPlaceholder
    }
  },
  watch: {
    [`signup.model.${fieldName}`]() {
      const fields = fieldName.split('.')
      if (fields.length === 1) {
        this.model = this.signup.model[fieldName]
      } else {
        this.model = this.signup.model[fields[0]][fields[1]]
      }
    }
  },
  methods: {
    ...mapMutations(['signupFieldOnInput']),
    onInput(val) {
      this.signupFieldOnInput({field: fieldName, value: val})
    }
  }
})
